module.exports = __webpack_public_path__ + "img/PG.15a3737f.png";